import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import type { FC } from "react";
import type { SaveDiscrepancies } from "../../sharedComponents/participantCountValidation";
import AsyncLoadingButton from "../asyncLoadingButton/AsyncLoadingButton";

interface Props {
  /** The dialog is open whenever discrepancies are present */
  readonly discrepancies: SaveDiscrepancies | null;
  readonly additionalInfo?: string;
  readonly onConfirm: () => Promise<void>;
  readonly onCancel: () => void;
}

const ParticipantCountDiscrepancyDialog: FC<Props> = ({ discrepancies, additionalInfo, onConfirm, onCancel }) => {
  const productBeds = discrepancies?.productBeds ?? [];
  const missingMandatoryOptions = discrepancies?.missingMandatoryOptions ?? [];
  return (
    <Dialog open={discrepancies !== null}>
      <DialogTitle>Ilość świadczeń jest niezgodna z wyceną</DialogTitle>
      <DialogContent>
        <Stack spacing={1}>
          {productBeds.length > 0 && (
            <>
              <Typography>Ilość osób {discrepancies?.participantsNumber}</Typography>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Produkt</TableCell>
                    <TableCell>Ilość łóżek</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {productBeds.map((item) => (
                    <TableRow key={item.productId}>
                      <TableCell>{item.productName}</TableCell>
                      <TableCell>{item.beds}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </>
          )}
          {missingMandatoryOptions.map((option) => (
            <Typography key={`${option.productId}/${option.optionName}`}>
              {`W produkcie ${option.productName} brak opcji wymaganej “${option.optionName}”`}
            </Typography>
          ))}
          {additionalInfo && <Typography>{additionalInfo}</Typography>}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button color="secondary" onClick={onCancel}>
          Wróć do edycji
        </Button>
        <AsyncLoadingButton onClick={onConfirm}>Zapisz</AsyncLoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default ParticipantCountDiscrepancyDialog;
